// extracted by mini-css-extract-plugin
export default {"tx":"_08ea07aeb7","line":"_4110850b1c"};